import { AuthState, User } from "../states/auth.state";
import * as AuthActions from '../actions/auth.action';
import { createReducer, on } from "@ngrx/store";

const INIT_STATE: AuthState = {
    tokenDetails: null,
    user: null,
};

export const authReducers = createReducer(
  INIT_STATE,
  on(
    AuthActions.GetUserTenantsSuccess,
    (state: AuthState, { tenants }): AuthState => ({
      ...state,
      user: {
        ...(state.user as User),
        tenants,
        active_tenant: tenants.find((tenant) => tenant.name !== 'root')!,
      },
    })
  ),
  on(
    AuthActions.GetUserRolesSuccess,
    (state: AuthState, { roles }): AuthState => ({
      ...state,
      user: {
        ...(state.user as User),
        roles,
        active_role: roles[0]!,
      },
    })
  ),
  on(
    AuthActions.GetUserFeaturesSuccess,
    (state: AuthState, { features }): AuthState => ({
      ...state,
      user: {
        ...(state.user as User),
        features,
      },
    })
  ),
  on(AuthActions.SetTokenDetails, (state: AuthState, { tokenDetails }): AuthState => {
    const given_name = tokenDetails.name
    const auth = { tokenDetails, user: { ...state.user, given_name } as User };
    return { ...state, ...auth };
  }),
  on(
    AuthActions.SetActiveTenant,
    (state: AuthState, { active_tenant }): AuthState => ({
      ...state,
      user: {
        ...(state.user as User),
        active_tenant,
      },
    })
  ),
  on(
    AuthActions.SetActiveRole,
    (state: AuthState, { active_role }): AuthState => ({
      ...state,
      user: {
        ...(state.user as User),
        active_role,
      },
    })
  ),
  on(AuthActions.Logout, (state: AuthState): AuthState => ({ ...state, tokenDetails: undefined, user: undefined }))
);
  